module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headline":"Plan your adventure.","organize_header":"Organize your gear","packing_header":"Forget nothing","share_header":"Inspire others"},"de":{"headline":"Plane dein Abenteuer","organize_header":"Organisiere deine Ausrüstung","packing_header":"Vergiss nichts mehr","share_header":"Inspiriere Andere"}}')
  delete Component.options._Ctor
}
